import { CloseIcon } from 'assets/icons/CloseIcon'
import { Modal } from 'components/Modal/Modal'
import useModalClose from 'hooks/useModalClose'
import { Button } from 'components/ui/Button/Button'
import { CursorPointer, Flex } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'
import { IGetAllFatigueOverridesSingleResponse } from 'types/api/operationsFatigueApi.interface'
import { formatDateForDisplay } from 'utils/helpers'

const formatUserName = (user: { firstName: string; lastName: string }) =>
  `${user.firstName} ${user.lastName}`

interface IFatigueOverridePreviewModal {
  closeModal: () => void
  value: IGetAllFatigueOverridesSingleResponse
}

export const FatigueOverridePreviewModal = ({ closeModal, value }: IFatigueOverridePreviewModal) => {
  useModalClose(closeModal)

  return (
    <Modal black>
      <Flex column between center>
        <Flex column gap='1rem' width='100%'>
          <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
            <TitleText weight='bold'>Override Preview</TitleText>
            <CursorPointer onClick={closeModal}>
              <CloseIcon />
            </CursorPointer>
          </Flex>
          <Flex column gap='0.5rem'>
            <TitleText weight='bold'>Worker</TitleText>
            <BodyText>{formatUserName(value.user)}</BodyText>
          </Flex>
          <Flex column gap='0.5rem'>
            <TitleText weight='bold'>Approved by</TitleText>
            <BodyText>{formatUserName(value.approvedByUser)}</BodyText>
          </Flex>
          <Flex column gap='0.5rem'>
            <TitleText weight='bold'>Reason</TitleText>
            <BodyText>{value.reason}</BodyText>
          </Flex>
          <Flex column gap='0.5rem'>
            <TitleText weight='bold'>Valid until</TitleText>
            <BodyText>{formatDateForDisplay(value.validUntil)}</BodyText>
          </Flex>
          <Flex column gap='0.5rem'>
            <TitleText weight='bold'>Created</TitleText>
            <BodyText>{formatDateForDisplay(value.createdAt)}</BodyText>
          </Flex>
        </Flex>
        <Button style={{ marginTop: '16px' }} variant='primary' onClick={closeModal}>
          Close
        </Button>
      </Flex>
    </Modal>
  )
}
